module.exports = __webpack_public_path__ + "img/bg_get.fd58c83.png";